// Centralized Lazy Firebase SDK Loader
const firebaseConfig = {
  apiKey: "AIzaSyAzfJXdiK05fCxqEv929EvmWN0Kc_E6OA4",
  authDomain: "teampulse-timekeeper.firebaseapp.com",
  projectId: "teampulse-timekeeper",
  storageBucket: "teampulse-timekeeper.firebasestorage.app",
  messagingSenderId: "1084825203431",
  appId: "1:1084825203431:web:fed24fb7eedaa8a55fa842",
  measurementId: "G-RZLNZXC2JN"
};

export interface FirebaseSDKs {
  app: any;
  auth: any;
  db: any;
  storage: any;
  analytics: any;
  authSdk: typeof import('firebase/auth');
  firestoreSdk: typeof import('firebase/firestore');
  functionsSdk: typeof import('firebase/functions');
  storageSdk: typeof import('firebase/storage');
  analyticsSdk: typeof import('firebase/analytics');
}

let firebasePromise: Promise<FirebaseSDKs> | null = null;

export const loadFirebaseSDK = async (): Promise<FirebaseSDKs> => {
  if (firebasePromise) return firebasePromise;

  firebasePromise = (async () => {
    const [appMod, authMod, firestoreMod, functionsMod, storageMod, analyticsMod] = await Promise.all([
      import('firebase/app'),
      import('firebase/auth'),
      import('firebase/firestore'),
      import('firebase/functions'),
      import('firebase/storage'),
      import('firebase/analytics')
    ]);

    const app = appMod.initializeApp(firebaseConfig);
    const auth = authMod.getAuth(app);
    const db = firestoreMod.initializeFirestore(app, {
      localCache: firestoreMod.persistentLocalCache({ tabManager: firestoreMod.persistentMultipleTabManager() })
    });
    const storage = storageMod.getStorage(app);
    let analytics: any = null;
    try {
      analytics = analyticsMod.getAnalytics(app);
    } catch (e) {}

    return {
      app,
      auth,
      db,
      storage,
      analytics,
      authSdk: authMod,
      firestoreSdk: firestoreMod,
      functionsSdk: functionsMod,
      storageSdk: storageMod,
      analyticsSdk: analyticsMod
    };
  })();

  return firebasePromise;
};
